/*
 *
 */
'use strict';

/*
 *
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.ExtSideTag = /*#__PURE__*/function () {
  function ExtSideTag(content, blockView, mode) {
    (0, _classCallCheck2["default"])(this, ExtSideTag);
    this.blockView = blockView;
    this.color = content.color ? content.color : '#EBC576';
    this.text = content.text ? content.text : '';
    this.height = content.height ? Number(content.height) : Number(content.count) * 31;
    this.render();
    this.updatePos();
  }
  return (0, _createClass2["default"])(ExtSideTag, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.svgGroup = this.blockView.svgGroup.elem('g');
      $(this.svgGroup).bind('mousedown touchstart', function (e) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }
        if (e.preventDefault) {
          e.preventDefault();
        }
      });
      this.path = this.svgGroup.elem('path').attr({
        d: "m0,2 h-9 v".concat(this.height - 4, " h9"),
        stroke: this.color,
        fill: 'transparent',
        'stroke-width': '3'
      });
      this.textElement = this.svgGroup.elem('text').attr({
        style: 'white-space: pre;',
        'font-size': '10px',
        'font-family': EntryStatic.fontFamily || 'NanumGothic',
        "class": 'dragNone',
        fill: '#000000'
      });
      var textArray = this.text.split('\n');
      this.tspans = textArray.map(function (t) {
        var tspan = _this.textElement.elem('tspan').attr({
          dy: '1.2em',
          x: '0',
          "class": 'extension sideTagTspan'
        });
        tspan.textContent = t;
        return tspan;
      });
    }
  }, {
    key: "updatePos",
    value: function updatePos() {
      var pointer = this.blockView.block.pointer();
      this.positionX = -(pointer.length - 2) * 8;
      this.svgGroup.attr('transform', "translate(".concat(this.positionX, ",0)"));
      this.textElement.attr({
        y: this.height / 2 - 12 * (this.tspans.length - 1) - 2
      });
      var bBox = this.textElement.getBoundingClientRect();
      this.tspans.map(function (tspan) {
        tspan.attr({
          x: -bBox.width - 14
        });
      });
    }
  }]);
}();